import './style.scss';

import CancellationAlertBell from '@/app/cancellations/components/AlertBell';
import HelpHeaderActions from '@/app/help-centre/components/HelpHeaderActions';
import { useDelegation } from '@/authz/delegation';

import { NotificationDropDownMenu } from '../../components/notification/drop-down';
import Can from '../../components/reusable/can';
import { ElectionSVG, HamburgerSVG } from '../../components/reusable/svgs';
import { ThemeToggle } from '../../components/reusable/theme-toggle';
import WalletNavWidget from '../../components/wallet/WalletNavWidget';
import { useOrganizationContext } from '../../context/organization';
import { useRightPanelContext } from '../../context/right-section';
import { ACTIONS } from '../permissions/actions';

const Header = () => {
	const rightPanel = useRightPanelContext();
	const organization = useOrganizationContext();
	const delegation = useDelegation();

	const hasElection = !!organization.selectedElection.electionId;

	const onOpenMenu = () => {
		rightPanel.callSection({
			action: 'view',
			component: 'side-menu-mobile',
			title: 'Menu',
		});
	};

	return (
		<div className='header-wrapper'>
			<div className='header-inner'>
				<div className='header-left'>
					<div
						className='after-lg hw-mx cursor-pointer'
						onClick={onOpenMenu}
					>
						<HamburgerSVG />
					</div>
				</div>

				{!organization.isObserver &&
					(hasElection ? (
						<button
							className='header-election header-election--active'
							onClick={!organization.isCandidate ? organization.onSelectElection : undefined}
							type='button'
							title={organization.selectedElection.electionName}
						>
							<div className='header-election__indicator' />
							<div className='header-election__content'>
								<span className='header-election__label'>Election</span>
								<span className='header-election__name'>{organization.selectedElection.electionName}</span>
							</div>
							{!organization.isCandidate && (
								<span className='header-election__change'>
									<svg
										width='14'
										height='14'
										viewBox='0 0 24 24'
										fill='none'
									>
										<path
											d='M9 18l6-6-6-6'
											stroke='currentColor'
											strokeWidth='2'
											strokeLinecap='round'
											strokeLinejoin='round'
										/>
									</svg>
								</span>
							)}
						</button>
					) : (
						<button
							className='header-election header-election--empty'
							onClick={!organization.isCandidate ? organization.onSelectElection : undefined}
							type='button'
						>
							<div className='header-election__icon'>
								<ElectionSVG />
							</div>
							<span className='header-election__empty-text'>No election selected</span>
							{!organization.isCandidate && <span className='header-election__select-cta'>Select Election</span>}
						</button>
					))}

				<div className='header-right'>
					<HelpHeaderActions />
					{/* Balance and top-up are the owner's. Team members see neither in P2 (wallet use is P3). */}
					{!delegation.isTeamMember && (
						<Can action={ACTIONS.MY_WALLET_VIEW}>
							<WalletNavWidget />
						</Can>
					)}
					<CancellationAlertBell />
					<NotificationDropDownMenu id='notificationdropdownMenuButton' />
					<ThemeToggle size='small' />
				</div>
			</div>
		</div>
	);
};

export default Header;
